import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

const StyledMuiDividerComponent = styled(Divider)({
  width: '100%',
  height: 1,
  backgroundColor: '#E0E0E0',
});

export default StyledMuiDividerComponent;
